import { z } from "zod";
import { PROJECT_STATES } from "../project/api/get-projects.schema";

export const ZodProjectState = z
	.enum(PROJECT_STATES)
	.nullish()
	.transform((value) => {
		if (!value) return "active";
		if (!PROJECT_STATES.includes(value)) return "active";
		return value;
	});
